import { render, staticRenderFns } from "./ProgressionStatus.vue?vue&type=template&id=c4e84296&"
import script from "./ProgressionStatus.vue?vue&type=script&lang=ts&"
export * from "./ProgressionStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports